import { useState } from 'react'
import Carousel from 'react-bootstrap/Carousel'

import 'bootstrap/dist/css/bootstrap.css'
import styles from './main.module.scss'

import { USE_TERMS } from '../../constants'
import { UseTerms } from '../../components/UseTerms'
import { Storage } from '../../constants/Enum'

import { Modal } from '../../components/Modal'
import { Blog } from './blog'
import { PeFriend } from './pe-friend'
import { Scholarships } from './scholarships'
import { PathInformation } from './path-information'
import { SearchCourse } from './searchCourse'
import { Capitalize } from './capitalize-form'

export default function MainPage() {
  const [category, setCategory] = useState('2')
  const [showModal, setShowModal] = useState(false)
  const [showTerms, setShowTerms] = useState(true)

  const acceptedUseTerms =
    localStorage.getItem(Storage.acceptedUseTerms) === 'accepted'

  const handleAcceptTerms = (accepted: boolean) => {
    const accept = accepted ? 'accepted' : 'noAccepted'
    localStorage.setItem(Storage.acceptedUseTerms, accept)
    setShowModal(false)
    setShowTerms(false)
  }

  return (
    <div className={styles.mainContainer}>
      {!acceptedUseTerms && showTerms && (
        <UseTerms
          openTerms={() => setShowModal(true)}
          handleAcceptTerms={handleAcceptTerms}
        />
      )}

      {showModal && (
        <Modal.Root title="Termos de uso" content={USE_TERMS}>
          <Modal.ButtonRoot>
            <Modal.Button
              labelText="Não concordo"
              handleClickButton={() => handleAcceptTerms(false)}
            />
            <Modal.Button
              labelText="Concordo"
              handleClickButton={() => handleAcceptTerms(true)}
              isPrimary
            />
          </Modal.ButtonRoot>
        </Modal.Root>
      )}

      <div className={styles.carousel}>
        <Carousel indicators={false}>
          <Carousel.Item>
            <img src="/banners/banner_1.jpg" alt="Banner do site 1" />
          </Carousel.Item>
          <Carousel.Item>
            <img src="/banners/banner_2.jpg" alt="Banner do site 2" />
          </Carousel.Item>
          <Carousel.Item>
            <img src="/banners/banner_5.jpg" alt="Banner do site 3" />
          </Carousel.Item>
        </Carousel>
      </div>

      <SearchCourse category={category} setCategory={setCategory} />

      <PathInformation />

      <Scholarships category={category} />

      <PeFriend />

      <Blog />

      <Capitalize />
    </div>
  )
}
